let state = {

}

let mutations = {

}

let actions = {

}

let moduleA = {
    namespaced: true,
    state,
    mutations,
    actions
}

export {
    moduleA
}


// WEBPACK FOOTER //
// ./src/store/moduleA.js